"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayStatusPeriod = void 0;
var PayStatusPeriod;
(function (PayStatusPeriod) {
    PayStatusPeriod["FirstPeriod"] = "first_period";
    PayStatusPeriod["SecondPeriod"] = "second_period";
})(PayStatusPeriod = exports.PayStatusPeriod || (exports.PayStatusPeriod = {}));
